import Radio from 'zarm/lib/radio';

Radio.defaultProps.prefixCls = 'zw-radio';
Radio.Group.defaultProps.prefixCls = 'zw-radio-group';
Radio.Group.defaultProps.compact = true;
Radio.Group.defaultProps.ghost = true;
Radio.Group.defaultProps.size = 'md';

export default Radio;
